module.exports = __webpack_public_path__ + "static/media/close.c58a06ee.svg";